import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import TableClasses from "Components/TableLoad";

import { FiPlus } from "react-icons/fi";
import { IoPencil } from "react-icons/io5";
import { MdDelete } from "react-icons/md";

import ImagePreview from "Components/ImagePreview";
import Moment from "react-moment";
import {
    showErrorAlert,
    showWarningAlert,
    confirmAction,
    Toast,
} from "Util/Alerts";

import { exclusiveType } from "./Types";

import { Get_Exclusive, Delete_Exclusive } from "Services/Requests";
// import {  } from "Util/Alerts";
import Styles from "Styles/Styles.module.css";

function ExclusiveComp() {
    const Navigate = useNavigate();
    let TableHead = ["IMAGE", "CREATED ON", "STATUS", "Actions"];
    const [Exclusives, setExclusives] = useState<exclusiveType[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    // State to handle modal visibility and the selected image
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);

    const getExclusives = async () => {
        try {
            const response = await Get_Exclusive();
            if (response?.data?.status === 1) {
                setExclusives(response?.data?.exclusives);
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        } finally {
            setLoading(false);
        }
    };

    const DeleteExclusive = async (id: any) => {
        setLoading(true);
        try {
            const response = await Delete_Exclusive(id);
            if (response?.data?.status === 1) {
                Toast("Exclusive Deleted Successfully", "success");
                getExclusives();
            } else {
                setLoading(false);
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            setLoading(false);
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        }
    };

    useEffect(() => {
        getExclusives();
    }, []);

    // Function to handle image click and show the modal
    const handleImageClick = (imageUrl: string) => {
        setSelectedImage(imageUrl);
        setIsModalVisible(true);
    };

    // Function to close the modal
    const handleCancel = () => {
        setIsModalVisible(false);
        setSelectedImage(null);
    };

    const deleteHandler = (item: exclusiveType) => {
        confirmAction(
            "Warning",
            "Are you sure you want to Delete Exclusive?",
            () => DeleteExclusive(item.exclusiveId),
            "Delete"
        );
    };
    return (
        <div className={Styles["Container"]}>
            <ImagePreview
                handleCancel={handleCancel}
                isModalVisible={isModalVisible}
                selectedImage={selectedImage}
                title="Exclusive"
            />
            <header>
                <h3>Exclusives</h3>
                <button
                    className={Styles["Add_cat_btn"]}
                    onClick={() => Navigate("/auth/exclusive/add")}>
                    <FiPlus />
                    Add Exclusive
                </button>
            </header>
            {loading ? (
                <TableClasses TableHead={TableHead} />
            ) : (
                <div className={Styles["tableWrapper"]}>
                    <table>
                        <thead>
                            {TableHead.map((item) => (
                                <th>{item}</th>
                            ))}
                        </thead>
                        <tbody>
                            {Exclusives.length > 0 ? (
                                Exclusives?.map((item) => (
                                    <tr key={item?.exclusiveId}>
                                        <td
                                            onClick={() =>
                                                handleImageClick(item.imageUrl)
                                            }>
                                            <div className={Styles["banner"]}>
                                                <img
                                                    src={item.imageUrl}
                                                    alt="Exclusive"
                                                />
                                            </div>
                                        </td>{" "}
                                        <td>
                                            <Moment format="DD-MM-YYYY" utc>
                                                {item.createdAt}
                                            </Moment>
                                        </td>
                                        <td>
                                            {item.status == 1 ? (
                                                <span
                                                    className={
                                                        Styles["Active"]
                                                    }>
                                                    Active
                                                </span>
                                            ) : (
                                                <span
                                                    className={
                                                        Styles["InActive"]
                                                    }>
                                                    InActive
                                                </span>
                                            )}
                                        </td>
                                        <td>
                                            <div
                                                className={
                                                    Styles["Action_Tabs"]
                                                }>
                                                <button
                                                    onClick={() =>
                                                        Navigate(
                                                            "/auth/exclusive/edit",
                                                            { state: item }
                                                        )
                                                    }>
                                                    <IoPencil size={24} />
                                                </button>

                                                <button
                                                    onClick={() =>
                                                        deleteHandler(item)
                                                    }>
                                                    <MdDelete size={22} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={TableHead.length}>
                                        No Exclusive Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default ExclusiveComp;
